/**
 * Interface for the 'Taxes' data
 */
export interface TaxesEntity {
  uuid: string
  auction: string
  label: string
  method: string
  tax_rate: string
}

export enum TaxMethodEnum {
  Add = 'add',
  Include = 'include',
}
